export default __webpack_public_path__ + "static/media/Nirmala.c975c53b.ttf";